import createIcon from '../../createIcon';

/**
 * @component @name Brightness4
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMjQwMl8yMzUyOCkiPgo8cGF0aCBkPSJNMjAuMDAwNCA4LjY4OTQ1VjMuOTk5NDVIMTUuMzEwNEwxMi4wMDA0IDAuNjg5NDUzTDguNjkwNDMgMy45OTk0NUg0LjAwMDQzVjguNjg5NDVMMC42OTA0MyAxMS45OTk1TDQuMDAwNDMgMTUuMzA5NVYxOS45OTk1SDguNjkwNDNMMTIuMDAwNCAyMy4zMDk1TDE1LjMxMDQgMTkuOTk5NUgyMC4wMDA0VjE1LjMwOTVMMjMuMzEwNCAxMS45OTk1TDIwLjAwMDQgOC42ODk0NVpNMTIuMDAwNCAxNy45OTk1QzExLjExMDQgMTcuOTk5NSAxMC4yNjA0IDE3Ljc5OTUgOS41MDA0MyAxNy40NDk1QzExLjU2MDQgMTYuNDk5NSAxMy4wMDA0IDE0LjQxOTUgMTMuMDAwNCAxMS45OTk1QzEzLjAwMDQgOS41Nzk0NSAxMS41NjA0IDcuNDk5NDUgOS41MDA0MyA2LjU0OTQ1QzEwLjI2MDQgNi4xOTk0NSAxMS4xMTA0IDUuOTk5NDUgMTIuMDAwNCA1Ljk5OTQ1QzE1LjMxMDQgNS45OTk0NSAxOC4wMDA0IDguNjg5NDUgMTguMDAwNCAxMS45OTk1QzE4LjAwMDQgMTUuMzA5NSAxNS4zMTA0IDE3Ljk5OTUgMTIuMDAwNCAxNy45OTk1WiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8yNDAyXzIzNTI4Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Brightness4 = createIcon('Brightness4', [
  ['g', { clipPath: 'url(#clip0_2402_23528)', key: '1vxddz' }],
  ['defs', { key: '9ahrjx' }],
]);

export default Brightness4;
